import { Collapse } from "@blueprintjs/core"
import { FieldProps } from "formik"
import { findIndex } from "lodash"
import { Caret } from "modules/common/components/collapse/Caret"
import { move } from "modules/common/services/array"
import { formatDate } from "modules/common/services/formatting/date"
import {
    OrderObjectSnapshotType,
    WorkTypeLinkSnapshotType,
    filterObjectUnits,
    getObjectsToDisplay
} from "modules/orders-manage/models/order"
import React from "react"
import { OTHER_WORKS } from "../constants"
import { Block } from "./Block"

import { observer } from "mobx-react"
import { OutsourcerDictionaryType } from 'modules/agents/outsourcers/models/outsourcer-dictionary'
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon"
import { DATE_TIME_FORMAT } from "modules/common/constants"
import { DictionaryLinkType } from 'modules/common/models/dictionary-link'
import { ProjectPortfolioDictionaryType } from 'modules/dictionaries/project-portfolios/models/project-portfolio-dictionary'
import {
    OrderContentTasksDictionaryType,
    OrderContentTasksListSnapshotType
} from "modules/orders-manage/models/order-content-tasks"
import { SectionCollapserType } from "modules/orders-manage/models/orders-store"
import { EmployerDictionaryType } from "modules/spending/employee/models/employee-dictionary"
import moment from "moment"
import styles from "./CategoryBlock.module.scss"

type TObject = OrderObjectSnapshotType
type TTasks = OrderContentTasksListSnapshotType
type TUnit = WorkTypeLinkSnapshotType

export const titleIndicator = "Кол-во неподтвержденных заданий и незаполненных заданий при наличии результата"

class CategoryBlockBase extends React.Component<CategoryBlockProps, CategoryBlockState> {
    constructor(props: CategoryBlockProps) {
        super(props)
        this.state = {
            implementerSelectKey: 0,
            showResetWarning: false,
            showDelete: false,
            workGuid: "",
            taskId: "",
            showUploadFiles: false,
            workFiles: [],
            taskFiles: [],
            selectedUnits: [],
            saveUnits: [],
            taskFiless: [],
            showAdd: false,
            showSheet: false,
            showUnits: false,
            description: "",
            isUploading: false,
            stopDate: null,
            isEditeMode: false,
            implementer: { id: "", label: "" },
            selectedType: { id: "", label: "" },
            legal: false,
            employersWorked: [],
            currentFileId: "",
            employersLegal: [],
        }
    }

    render() {
        const {
            category,
            onToggleCollapse,
            collapsed,
            objects,
            readOnly,
            fieldProps,
            store,
            baseUrl,
            orderId, orderName,
            user,
            collapserContent,
            highlightRow, userId,
            selectedBlockGuid,
            onSelectBlock,
        } = this.props

        const objectsToDisplay = getObjectsToDisplay(category, objects)

        // const progress = getCategoryProgress(category, objectsToDisplay)
        const touched = !!fieldProps.form.touched[fieldProps.field.name]
        const allUnits = objects.flatMap((o) => o.content)
        const categoriesMap = new Map()
        allUnits.forEach((u) => {
            const cat = u.workTypeCategory
            if (!categoriesMap.has(cat)) {
                categoriesMap.set(cat, [])
            }
            categoriesMap.get(cat).push({
                guid: u.guid,
                name: u.name,
                category: cat
            })
        })


        let newItems: WorkTypeLinkSnapshotType[] = []

        objects.forEach((object, i) => {
            object.content.forEach((unit) => {
                newItems.push(unit)
            })
        })

        // let allTasksCount = 0
        // objectsToDisplay.forEach((object, i) => {
        //     // checked work types sorted by user order
        //     const filteredUnits = filterObjectUnits(object, category)
        //     // original indexes for dnd sorting
        //     filteredUnits.forEach((unit) => {
        //         const contentTask = store.contentTasksList.filter((item) => item.guid === unit.guid)[0]
        //         let tasksCount = 0
        //         if (contentTask) {
        //             tasksCount = contentTask.tasks.filter((t) => t.confirmed === false).length

        //             if (tasksCount > 0) {
        //                 allTasksCount += tasksCount
        //             }
        //         }

        //     })
        // })

        const categoryIndicatorType = this.getCategoryIndicatorType(category)


        return (
            <div className={styles.categoryBlock}>

                <h1 className="planr-block-header collapser" onClick={onToggleCollapse}>
                    <div className={styles.indicator}>
                        {/* {allTasksCount > 0 && (
                            <span className={styles.countIndicator} title={titleIndicator}>
                                {allTasksCount}
                            </span>
                        )} */}
                        {categoryIndicatorType === 'unsigned' && (
                            <span className={styles.hasUnsigned}>
                                <GeneralIcon type="general-exclamation" style={{ marginRight: '4px', color: '#e31818' }} />
                            </span>
                        )}
                        {categoryIndicatorType === 'allSigned' && (
                            <span className={styles.allSigned}>
                                <GeneralIcon type="general-check" style={{ marginRight: '4px', color: '#1DD278' }} />
                            </span>
                        )}
                    </div>
                    {category || OTHER_WORKS}

                    <Caret collapsed={collapsed} />
                </h1>

                <Collapse isOpen={!collapsed} keepChildrenMounted={true}>
                    <div className="collapse">
                        <div className={styles.blocksList}>
                            {objectsToDisplay.map((object, i) => {
                                // checked work types sorted by user order
                                const filteredUnits = filterObjectUnits(object, category)
                                    // original indexes for dnd sorting
                                    .map((unit) => ({ unit, index: object.content.indexOf(unit) }))

                                return (
                                    <div key={object.guid} className={styles.content}>
                                        <div>
                                            {category && (
                                                <div className={styles.objectTitle}>{object.name || "Общее"}</div>
                                            )}
                                            <Block
                                                // activation={({ onActivate }) => (activation = onActivate)}
                                                category={category}
                                                touched={touched}
                                                units={filteredUnits}
                                                collapserContent={collapserContent}
                                                onSort={(from, to) => this.resortUnits(object, from, to)}
                                                onChange={this.setTasksValue}
                                                readOnly={readOnly}
                                                store={store}
                                                baseUrl={baseUrl}
                                                orderId={orderId}
                                                orderName={orderName}
                                                toggleDeleteShow={this.toggleDeleteShow}
                                                toggleShowUploadFiles={this.showUploadFilesDialog}
                                                showAddTask={this.showAddTask}
                                                user={user}
                                                userId={userId}
                                                setTaskId={(id: string) => {
                                                    this.setState({ taskId: id })
                                                }}
                                                setGuid={(guid: string) => {
                                                    this.setState({ workGuid: guid })
                                                }}
                                                showEditTask={this.showEditTask}
                                                showDevelopersDialog={this.showDevelopersDialog}
                                                highlightRow={highlightRow}
                                                selectedUnitGuid={selectedBlockGuid}
                                                onClick={onSelectBlock}
                                            />
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </Collapse>
            </div>
        )
    }

    // Добавьте этот метод в класс CategoryBlockBase
    getCategoryIndicatorType = (category: string): 'none' | 'unsigned' | 'allSigned' => {
        const { objects, store } = this.props

        // Собираем все GUID unit в этой категории
        const unitGuids: string[] = []
        objects.forEach((object) => {
            const filteredUnits = filterObjectUnits(object, category)
            filteredUnits.forEach((unit) => {
                unitGuids.push(unit.guid)
            })
        })

        if (unitGuids.length === 0) return 'none'

        let hasAnyFiles = false
        let allSigned = true
        let hasUnsigned = false

        // Проверяем каждый unit в категории
        unitGuids.forEach((guid) => {
            const contentTask = store.contentTasksList.find((item) => item.guid === guid)

            if (contentTask && contentTask.resultFiles && contentTask.resultFiles.length > 0) {
                hasAnyFiles = true
                const resultFiles = contentTask.resultFiles

                // Группируем файлы по имени и берем последнюю версию
                const resultFilesByName = resultFiles.reduce((acc, file) => {
                    if (!acc[file.name]) {
                        acc[file.name] = []
                    }
                    acc[file.name].push(file)
                    return acc
                }, {} as Record<string, any[]>)

                const latestResultFiles = Object.values(resultFilesByName).map((files) =>
                    files.sort((a, b) => b.version - a.version)[0]
                )

                // Проверяем файлы этого unit
                latestResultFiles.forEach((file) => {
                    if (!file.signatures || file.signatures.length === 0) {
                        allSigned = false
                        hasUnsigned = true
                    } else {
                        const fileAllSigned = file.signatures.every((s: any) => s.signed === true)
                        if (!fileAllSigned) {
                            allSigned = false
                            hasUnsigned = true
                        }
                    }
                })
            }
        })

        if (!hasAnyFiles) return 'none'
        if (allSigned) return 'allSigned'
        if (hasUnsigned) return 'unsigned'

        return 'none'
    }



    toggleDeleteShow = () => {
        this.setState({ showDelete: !this.state.showDelete })
    };

    toggleShowUploadFiles = () => {
        this.setState({ showUploadFiles: !this.state.showUploadFiles, isUploading: false })
    };

    deleteTask = (id: string) => {
        this.props.store.deleteTaskTemp(id)
        this.setTasksValue(this.props.store.contentTasksList)
    };

    setTasksValue = (newTasks: TTasks[]) => {
        this.props.fieldProps.form.setFieldValue(this.props.fieldProps.field.name, newTasks)
        this.props.fieldProps.form.setFieldTouched(this.props.fieldProps.field.name, true)
    };

    taskFilesUpload = async (file: File) => {
        const result = await this.props.store.uploadFile(file)
        if (result) {
            const newFile = { id: result?.fileId, name: result?.fileName }

            this.setState({ taskFiless: [...this.state.taskFiless, newFile] })
        }
    };

    taskFilesLoad = async (file: any) => {
        const result = await this.props.store.uploadFile(file)
        if (result) {
            const files = [...this.state.taskFiles]
            files.push({ id: result?.fileId, name: result?.fileName, path: "" })
            this.setState({ taskFiles: files })
        }
    };

    removeWorkFilesFromState = (fileId: string) => {
        this.setState({ workFiles: this.state.workFiles.filter((item) => item.id !== fileId) })
    };

    removeTaskFilesFromState = (fileId: string) => {
        this.setState({ taskFiless: this.state.taskFiless.filter((item) => item.id !== fileId) })
    };

    workFilesUpload = async (file: File) => {
        const result = await this.props.store.uploadFile(file)
        if (result) {
            const newFile = { id: result?.fileId, name: result?.fileName }

            this.setState({ workFiles: [...this.state.workFiles, newFile] })
        }
    };

    saveUploadedWorkFiles = async () => {
        if (this.state.isUploading) {
            return
        }

        this.setState({ isUploading: true })

        const result = await this.props.store.saveWorkFiles(
            this.props.orderId,
            this.state.workGuid,
            this.state.workFiles,
            this.state.taskFiless
        )

        if (result) {
            this.toggleShowUploadFiles()
        } else {
            this.setState({ isUploading: false })
        }
    };

    showUploadFilesDialog = () => {
        this.setState({ workFiles: [], taskFiless: [] })
        this.toggleShowUploadFiles()
    };

    showSelectedUnits = () => {
        this.setState({ showUnits: true, selectedUnits: [...this.state.saveUnits] })
    };

    setSelectedUnits = (guid: string) => {
        let newUnits = [...this.state.selectedUnits]
        const index = newUnits.findIndex((unit) => unit === guid)
        let newArr: string[] = newUnits
        if (index > -1) {
            newArr = [...newUnits.slice(0, index), ...newUnits.slice(index + 1)]
        } else {
            newArr.push(guid)
        }
        this.setState({ selectedUnits: newArr })
    };

    setSaveUnits = (guid: string) => {
        let newUnits = [...this.state.saveUnits]
        const index = newUnits.findIndex((unit) => unit === guid)
        let newArr: string[] = newUnits
        if (index > -1) {
            newArr = [...newUnits.slice(0, index), ...newUnits.slice(index + 1)]
        } else {
            newArr.push(guid)
        }
        this.setState({ saveUnits: newArr })
    };

    saveSelectedUnits = () => {
        this.setState({ saveUnits: this.state.selectedUnits, selectedUnits: [], showUnits: false })
    };

    cancelSelectedUnits = () => {
        this.setState({ selectedUnits: [], showUnits: false })
    };

    closeAddDialog = () => {
        this.setState({ showAdd: false })
    };

    saveTask = async (id: string, guid: string, user: string) => {
        const { taskFiles, description, saveUnits, implementer, stopDate } = this.state
        const employer = this.props.employee.employee.find((emp) => emp.id === implementer.id)
        const result = await this.props.store.addTaskTemp(
            id,
            saveUnits,
            description,
            formatDate(stopDate),
            taskFiles,
            user,
            implementer,
            employer
        )
        if (result) {
            this.setTasksValue(this.props.store.contentTasksList)
            this.closeAddDialog()
        }
    };

    showAddTask = (guid: string) => {
        this.setState({
            showAdd: true,
            description: "",
            taskFiles: [],
            saveUnits: [guid],
            isEditeMode: false,
            stopDate: null,
            implementer: { id: "", label: "" },
        })
    };

    showEditTask = (
        description: string,
        stopDate: string | null,
        taskFiles: TTaskFilePath[],
        guid: string,
        employerId: string | null
    ) => {
        const implement = this.props.employee.employee.find((emp) => emp.id === employerId)
        this.setState({
            showAdd: true,
            description,
            taskFiles: [...taskFiles],
            isEditeMode: true,
            stopDate: stopDate ? moment(stopDate, DATE_TIME_FORMAT).toDate() : null,
            saveUnits: [guid],
            implementer: implement ? { id: implement.id, label: implement.name } : { id: "", label: "" },
        })
    };

    toggleShowDevelopers = () => {
        this.setState({ showSheet: !this.state.showSheet, employersWorked: [], employersLegal: [], implementer: { id: "", label: "" }, selectedType: { id: "", label: "" }, legal: false })
    };



    removeDeveloper = (indexItem: number, type: TWorkType) => {
        if (type !== 'legal') {
            this.setState({ employersWorked: this.state.employersWorked.filter((item, index) => index !== indexItem) })
        }
        if (type === 'legal') {
            this.setState({ employersLegal: this.state.employersLegal.filter((item, index) => index !== indexItem) })
        }
    };


    addNewDeveloper = () => {
        const { implementer, selectedType } = this.state
        if (implementer.id === '' || selectedType.id === '') return
        // Очищаем label от префиксов (сотр) и (аутс)
        let cleanName = implementer.label
        // Удаляем "(сотр) " в начале строки
        if (cleanName.startsWith('(сотр) ')) {
            cleanName = cleanName.substring(7) // длина "(сотр) " = 7
        }
        // Удаляем "(аутс) " в начале строки
        if (cleanName.startsWith('(аутс) ')) {
            cleanName = cleanName.substring(7) // длина "(аутс) " = 7
        }
        let newItem = {
            id: this.state.implementer.id,
            name: cleanName, // Используем очищенное имя
            type: (selectedType.id as any),
            signed: false
        }


        this.setState({ employersWorked: [...this.state.employersWorked, newItem] })
        this.setState({
            implementer: { id: "", label: "" }, selectedType: { id: "", label: "" }, implementerSelectKey: this.state.implementerSelectKey + 1
        })
    }

    addNewLegal = (employer: SelectItem) => {
        if (employer.id === '') return
        const newItem = {
            id: employer.id, name: employer.label, type: ('legal' as any),
            signed: false

        }
        this.setState({ employersLegal: [...this.state.employersLegal, newItem] })
        // this.setState({ legaler: { id: "", label: "" } })
    }

    saveDevelopers = async () => {

        // Получаем текущий файл, для которого настраиваются подписи
        const contentTask = this.props.store.contentTasksList.find(
            (item) => item.guid === this.state.workGuid
        )

        if (!contentTask) return

        // Находим файл результата
        const resultFile = contentTask.resultFiles?.find(
            (f) => f.id === this.state.currentFileId
        )
        if (!resultFile) return

        // Проверяем, есть ли среди существующих подписантов те, кого удалили из списка
        const existingSigners = resultFile.signatures || []

        // Создаем множество ID текущих подписантов из формы
        const currentSignerIds = new Set([
            ...this.state.employersWorked.map((e) => e.id),
            ...this.state.employersLegal.map((e) => e.id)
        ])

        // Находим подписантов, которые были в файле, но отсутствуют в новой форме
        const removedSigners = existingSigners.filter(
            (signer) => !currentSignerIds.has(signer.employerId)
        )

        // Проверяем, были ли у удаленных подписантов реальные подписи
        const hadSignatures = removedSigners.some((signer) => signer.signed)

        if (hadSignatures) {
            // Показываем предупреждение
            this.setState({ showResetWarning: true })
            return
        }

        // Если нет удаленных подписантов с подписями, сохраняем сразу
        await this.performSaveDevelopers()
    }

    confirmSaveDevelopers = async () => {
        this.setState({ showResetWarning: false })
        await this.performSaveDevelopers()
    }

    performSaveDevelopers = async () => {
        const result = await this.props.store.saveDevelopers(
            this.props.orderId,
            this.state.workGuid,
            this.state.currentFileId,
            this.state.employersWorked,
            this.state.employersLegal,
            this.state.legal
        )

        if (result) {
            this.toggleShowDevelopers()
        }
    }

    showDevelopersDialog = (guid: string, fileId: string) => {
        // Находим файл по fileId в текущем разделе
        const contentTask = this.props.store.contentTasksList.find(
            (item) => item.guid === guid
        )

        if (contentTask) {
            const file = contentTask.resultFiles.find((f) => f.id === fileId)
            if (file) {
                this.setState({
                    showSheet: true,
                    workGuid: guid,
                    currentFileId: fileId,
                    employersWorked: file.signatures?.filter((f) => f.signerType !== 'legal').map((s) => ({
                        id: s.employerId,
                        name: s.employerName,
                        type: s.signerType as TWorkType,
                        signed: s.signed
                    })) || [],
                    employersLegal: file.signatures?.filter((f) => f.signerType === 'legal').map((s) => ({
                        id: s.employerId,
                        name: s.employerName,
                        type: s.signerType as TWorkType,
                        signed: s.signed

                    })) || [],
                    legal: (file.signatures?.filter((f) => f.signerType === 'legal').length || 0) > 0
                })
            }
        }
    }

    resetFiles = (id: string) => {
        const files = [...this.state.taskFiles]

        const index = files.findIndex((f) => f.id === id)

        if (index > -1) {
            const newFiles = [...files.slice(0, index), ...files.slice(index, files.length - 1)]
            this.setState({ taskFiles: newFiles })
        }
    }

    //////////////////////////////////////////////////////////////////

    setFieldValue = (newObjects: TObject[]) => {
        this.props.fieldProps.form.setFieldValue(this.props.fieldProps.field.name, newObjects)
        this.props.fieldProps.form.setFieldTouched(this.props.fieldProps.field.name, true)
    }

    showType = (type: TWorkType) => {
        const found = signatureTypeList.find((item) => item.id === type)
        return found?.label || type
    }

    resortUnits = (object: TObject, from: number, to: number) => {
        if (from !== to) {
            const { objects } = this.props
            const position = findIndex(objects, (o) => o.guid === object.guid)

            const content = move(object.content, from, to)
            const newObjects = [
                ...objects.slice(0, position),
                {
                    ...object,
                    content,
                },
                ...objects.slice(position + 1),
            ]

            this.setFieldValue(newObjects)
        }
    }
}

export const CategoryBlock = observer(CategoryBlockBase)

interface CategoryBlockProps {
    portfolios: ProjectPortfolioDictionaryType
    employer: DictionaryLinkType | null
    fieldProps: FieldProps
    category: string
    readOnly: boolean
    objects: TObject[]
    collapsed: boolean
    onToggleCollapse: () => void
    store: OrderContentTasksDictionaryType
    baseUrl: string
    orderId: string
    orderName: string
    user: string
    userId: string
    collapserContent: SectionCollapserType
    employee: EmployerDictionaryType
    agents: OutsourcerDictionaryType
    orderPortfolioId: string
    highlightRow?: string
    selectedBlockGuid: string | null
    onSelectBlock: (guid: string) => void
}

interface CategoryBlockState {
    implementerSelectKey: number
    showResetWarning: boolean
    showDelete: boolean
    showUploadFiles: boolean
    showAdd: boolean
    showSheet: boolean
    isEditeMode: boolean
    showUnits: boolean
    workGuid: string
    taskId: string
    description: string
    workFiles: TTaskFile[]
    taskFiless: TTaskFile[]
    taskFiles: TTaskFilePath[]
    selectedUnits: string[]
    saveUnits: string[]
    employersWorked: TResultWorker[]
    employersLegal: TResultWorker[]
    isUploading: boolean
    stopDate: Date | null
    implementer: { id: string; label: string }
    selectedType: { id: string; label: string }
    legal: boolean
    currentFileId: string
}

export interface Selection {
    category: string
    object: string
    units: TUnit[]
}
interface TTaskFile {
    id: string
    name: string
}
export interface TTaskFilePath {
    id: string
    name: string
    path: string
}
interface TTaskDevelopers {
    name: string
    type: string
}

interface TResultWorker {
    id: string
    name: string
    type: TWorkType
    signed: boolean
}


type TWorkType = 'worked' | 'checked' | 'control' | 'legal'

export const signatureTypeList: SelectItem[] = [
    { id: 'worked', label: 'Разработал' },
    { id: 'checked', label: 'Проверил' },
    { id: 'control', label: 'Нормоконтроль' },
    { id: 'leader', label: 'Начальник отдела' },
    { id: 'gip', label: 'ГИП' },
] 